import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'partsFilter',
    pure: false,
    standalone: false
})
export class PartsFilterPipe implements PipeTransform {
  transform(items: Array<any>, filter: any): any {
    let filteredItems = [...items];
    for (const key in filter) {
      if (filter.hasOwnProperty(key)) {
        if (filter[key]) {
          filteredItems = filteredItems.filter((item) => {
            return item[key] && item[key].toLowerCase().includes(filter[key].toLowerCase());
          });
        }
      }
    }
    return filteredItems;
  }
}
